import type { IconProps } from '../types/IconProps.ts';
export const Compass: IconProps = {
    name: 'Compass',
    children: [
        `<circle cx="12" cy="12" r="10" />`,
        `<path d="m13.05 14.32-4.67 1.55a.2.2 0 0 1-.25-.25l1.55-4.67a2 2 0 0 1 1.27-1.27l4.67-1.55c.16-.06.3.1.25.25l-1.55 4.67a2 2 0 0 1-1.27 1.27" />`,
    ]
};